import { SUPPORTED_LANGUAGES } from '@/common/utils/language';

const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[2];

export const resolveCurrentLanguage = (lang) =>
	SUPPORTED_LANGUAGES.find((item) => item.code === lang) ?? DEFAULT_LANGUAGE;
